import * as PropTypes from "prop-types"
import styled, { css } from "styled-components"
import Image from "next/legacy/image"
import { color, mq } from "helpers/styled"
import Typography from "components/styled/Typography"

export const baseCard = css`
  display: flex;
  border-radius: 14px;
  border: var(--promo-border, solid 0.8px ${color("white")});
  box-shadow: 0 2px 14px 0 rgba(195, 205, 224, 0.7);

  @media ${mq("lg")} {
    min-height: 95px;
  }

  * {
    color: inherit;
  }
`

export const Card = styled.div`
  ${baseCard};
  padding: 10px;
  background: var(--promo-bg);
  color: var(--promo-color, ${color("white")});
`

const ImageWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-right: 10px;
  padding: 8px;
  background-color: ${color("white")};
  border-radius: 50%;
`

const TextWrapper = styled.div`
  padding: 3px 0;

  > :first-child:not(:only-child) {
    margin-bottom: 5px;
  }
`

function Item({ title, description, image, alt, className }) {
  return (
    <Card className={className}>
      {image && (
        <ImageWrapper>
          <Image alt={alt || image} src={`/f_auto,c_limit,w_32,q_auto/f_svg/static/${image}`} width={32} height={32} />
        </ImageWrapper>
      )}
      <TextWrapper>
        {title && (
          <Typography variant="label" weight="bold">
            {title}
          </Typography>
        )}
        {description && <Typography variant="small">{description}</Typography>}
      </TextWrapper>
    </Card>
  )
}

Item.defaultProps = {
  alt: null
}

Item.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default Item
